import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core';
import styles from '../BeneficiosMGMResumo.style';

const useStyles = makeStyles(styles);

export const BeneficiosMGMResumo = ({ grantedCount }) => {
  const classes = useStyles();

  const resumo = {
    totalOfIndicated: grantedCount?.totalOfIndicated || 0,
    totalWithoutBenefits: grantedCount?.totalWithoutBenefits || 0,
    totalOfBenefitsGranted: grantedCount?.totalOfBenefitsGranted || 0,
    totalOfIndicatedCustomer: grantedCount?.totalOfIndicatedCustomer || 0,
    totalOfIndicatedCoempreendedor: grantedCount?.totalOfIndicatedCoempreendedor || 0,
    totalBenefits: grantedCount?.totalOfIndicated * 2 || 0,
  };

  return (
    <Box mb={2}>
      <Grid container spacing={1}>
        <Paper className={classes.paper}>
          <Grid container spacing={1} justifyContent="flex-start">
            <Grid item xs={1}>
              <Box px={2} py={4}>
                <Typography variant="h6">Resumo</Typography>
              </Box>
            </Grid>

            <Grid item xs={11}>
              <Box pl={1}>
                <Box mb={1}>
                  <Typography variant="subtitle1">Benefícios</Typography>
                </Box>
                <Divider component="hr" />
                <Box mt={2} display="flex" alignItems="baseline" justifyContent="space-between">
                  <Box display="flex" alignItems="flex-end" className={classes.box}>
                    <Typography color="primary" variant="h4" className={classes.fontWeight400}>
                      {resumo.totalOfIndicated}
                    </Typography>
                    <Box width="60px" ml="4px">
                      <Typography variant="caption">Indicações CRM</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="flex-end" className={classes.box}>
                    <Typography color="primary" variant="h4" className={classes.fontWeight400}>
                      {resumo.totalOfIndicatedCustomer}
                    </Typography>
                    <Box width="60px" ml="4px">
                      <Typography variant="caption">Indicações Clientes</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="flex-end" className={classes.box}>
                    <Typography color="primary" variant="h4" className={classes.fontWeight400}>
                      {resumo.totalOfIndicatedCoempreendedor}
                    </Typography>
                    <Box width="60px" ml="4px">
                      <Typography variant="caption">Indicações Coempreendedor</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="flex-end" className={classes.box}>
                    <Typography color="primary" variant="h4" className={classes.fontWeight400}>
                      {resumo.totalBenefits}
                    </Typography>
                    <Box width="60px" ml="4px">
                      <Typography variant="caption">Total Benefícios</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="flex-end" className={classes.box}>
                    <Typography color="primary" variant="h4" className={classes.fontWeight400}>
                      {resumo.totalOfBenefitsGranted}
                    </Typography>
                    <Box width="60px" ml="4px">
                      <Typography variant="caption">Concluídos</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="baseline" pt={1} className={classes.box}>
                    <Typography variant="h4" className={classes.colorDanger} style={{ fontWeight: 400 }}>
                      {resumo.totalWithoutBenefits}
                    </Typography>
                    <Box ml="4px">
                      <Typography variant="caption">Não concluídos</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" alignItems="baseline" pt={1} className={classes.box}>
                    <Typography variant="h4" style={{ fontWeight: 400 }}>
                      {resumo.totalBenefits > 0
                        ? Number((resumo.totalOfBenefitsGranted / resumo.totalBenefits) * 100).toFixed(0)
                        : 0}
                      %
                    </Typography>
                    <Box ml="4px">
                      <Typography variant="caption">Eficiência</Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Box>
  );
};
